export enum PriorityLevel {
    Blocked = 'Blocked',
    Major = 'Major',
    Minor = 'Minor'
}

export enum PriorityLevelMessages {
    Blocked = 'This issue prevents me from completing my work or blocks the use of the product.',
    Major = 'This issue greatly impacts my work on a project but does not block me.',
    Minor = 'This issue does not hinder my ability to complete my work or use the product effectively.'
}